"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loginApiResponseSchema = void 0;
const zod_1 = require("zod");
const user_1 = require("../users/user");
exports.loginApiResponseSchema = zod_1.z.object({
    data: zod_1.z.object({
        id: zod_1.z.string().uuid(),
        type: zod_1.z.literal('users'),
        attributes: zod_1.z.object({
            email: zod_1.z.string().email(),
            role: user_1.userRoleSchema,
        }),
    }),
});
